import slice from './slice';

const { reducer } = slice;
export { reducer as ConfirmReducer }; 

export * from './actions';
export * from './selectors';